import { render, staticRenderFns } from "./LmCheckbox.vue?vue&type=template&id=2bd75062&scoped=true&"
import script from "./LmCheckbox.vue?vue&type=script&lang=js&"
export * from "./LmCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./LmCheckbox.vue?vue&type=style&index=0&id=2bd75062&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd75062",
  null
  
)

export default component.exports